import {
  fallbackUploadSidecarForPersistedWorkflow,
  recordingEntryFromPersistedWorkflow,
} from '@/app-shell/rpa/recorder/lib/recording-entry-from-persisted';
import { logger } from '@/utils/logger/logger';
import type { RecordingEntry } from '@heidi/agents/data';
import type { RecorderUploadSidecar, Workflow } from '@heidi/plugin-rpa';

export interface HydratePersistedRecordingsDeps {
  readonly listRecordings: () => Promise<readonly Workflow[]>;
  readonly getUploadState: (sessionId: string) => Promise<RecorderUploadSidecar>;
}

export async function hydratePersistedRecordings(
  deps: HydratePersistedRecordingsDeps,
  mergePersisted: (entries: readonly RecordingEntry[]) => void
): Promise<void> {
  let workflows: readonly Workflow[];
  try {
    workflows = await deps.listRecordings();
  } catch (error) {
    logger.warn({
      msg: '[rpa-recorder] Failed to list persisted recordings for hydration',
      error: error instanceof Error ? error.message : String(error),
    });
    return;
  }

  const entries: RecordingEntry[] = [];

  for (const workflow of workflows) {
    let uploadState: RecorderUploadSidecar;
    try {
      uploadState = await deps.getUploadState(workflow.id);
    } catch (error) {
      logger.warn({
        msg: '[rpa-recorder] Failed to read upload state for persisted recording; using disk fallback',
        sessionId: workflow.id,
        error: error instanceof Error ? error.message : String(error),
      });
      uploadState = fallbackUploadSidecarForPersistedWorkflow(workflow);
    }
    entries.push(recordingEntryFromPersistedWorkflow(workflow, uploadState));
  }

  if (entries.length > 0) {
    mergePersisted(entries);
  }
}
